import React, { useEffect, useState } from 'react';
import '../css/header.css';
import Loader from './Loader';
import HeroSection from './HeroSection';
import Work from './Work';
import Footer from './Footer';
import { FaConnectdevelop } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import WhatsApp from './WhatsApp';

function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const activeLink = location.hash;


  const isActive = (hash) => activeLink === hash ? 'active' : '';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  return (
    <>
      <body className='__variable_f483f7 __variable_b72822 __variable_a94918 light loaded'>
        <Loader />

        <WhatsApp />
        <main id='home'>
          <div id='hero'>
            <header>
              <div className='name'>
                <p>Ravi Kant</p>
                <p style={{ display: "flex", fontWeight: "bold" }}>
                  Flutter Developer  &nbsp;
                  <FaConnectdevelop
                    style={{
                      fontSize: "25px",
                      animation: "rotate 2s linear infinite",
                    }}
                  />
                </p>
              </div>
              <nav id="menu" className={isSticky ? "sticky" : ""}>
                <figure style={{ left: "2px" }}></figure>
                <div>
                  <a href="#hero" className={isActive("#hero") ? "active" : ""}>About</a>
                  <a href="#work" className={isActive("#work") ? "active" : ""}>Work</a>
                  <a href="#playground" className={isActive("#playground") ? "active" : ""}>Playground</a>
                  <a href="#contact" className={isActive("#contact") ? "active" : ""}>Contact</a>
                </div>
              </nav>
            </header>
            <button id='btn-menu'></button>

            <HeroSection />
          </div>

          <Work />
          <Footer />
        </main>
      </body>
    </>
  )
}

export default Header